import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async createCashOutput(
        { commit, dispatch },
        {
            concept,
            merchantId,
            merchantType,
            needDecrease,
            receiptFile,
            sourcePay,
            supplierId,
            value,
            valuePaid
        }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/cash-outputs", {
                concept,
                merchantId,
                merchantType,
                needDecrease,
                supplierId,
                receiptFile,
                sourcePay,
                value,
                valuePaid
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CASH_OUTPUTS", parseError);
            throw parseError;
        }
    },

    async listCashOutputsPaginated(
        { commit, dispatch },
        {
            agoDays,
            agoMonths,
            begin,
            complete,
            end,
            itemsByPage,
            merchantId,
            merchantType,
            page
        }
    ) {
        try {
            const { data } = await Http.instance.get(
                `/bo/cash-outputs/${merchantType}/${merchantId}`,
                {
                    params: {
                        agoDays,
                        agoMonths,
                        begin,
                        complete,
                        end,
                        itemsByPage,
                        page
                    }
                }
            );

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CASH_OUTPUTS", parseError);
            throw parseError;
        }
    },

    async getCashOutputById(
        { commit, dispatch },
        { id, merchantId, merchantType }
    ) {
        try {
            const { data } = await Http.instance.get(
                `/bo/cash-outputs/${merchantType}/${merchantId}/${id}`
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CASH_OUTPUTS", parseError);
            throw parseError;
        }
    }
};

export default actions;
